import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const getToastId = (pageId: string) => `remove-manager-page-${pageId}`;

export const removeManagerPage: managerTypes.RemoveManagerPage = (params) => {
  return axios.delete(`/manager/page`, { params });
};

type UseRemoveManagerPageOptions = {
  config?: MutationConfig<typeof removeManagerPage>;
};

export function useRemoveManagerPage({ config = {} }: UseRemoveManagerPageOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (variables) => {
      managerMutationToasts.loading(getToastId(variables.pageId), 'Removing page...');
      config.onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(['managers']);
      managerMutationToasts.success(getToastId(variables.pageId), 'Page removed successfully');
      config.onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(getToastId(variables.pageId), serverMessage);
      config.onError?.(error, variables, context);
    },
    mutationFn: removeManagerPage,
  });
}
